import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CustomizedDataGrid from './CustomizedDataGrid';
import PageViewsBarChart from './PageViewsBarChar';
import SessionsChart from './SessionChart';
import { StatCardProps } from './StatCard';
import { Button, Card, CardActionArea, CardActions, CardContent, CardMedia, Paper, styled } from '@mui/material';
import { useState, useEffect } from 'react';
import createUserService from '../utils/UserService';
import { useNavigate } from 'react-router-dom';
import { Add, AddCircle } from '@mui/icons-material';
import { useLanguage } from '../contexts/LanguageContext'; // ✅ Import language context


const data: StatCardProps[] = [
  {
    title: 'Customers',
    value: '14k',
    interval: 'Last 30 days',
    trend: 'up',
    data: [
      200, 24, 220, 260, 240, 380, 100, 240, 280, 240, 300, 340, 320, 360, 340, 380,
      360, 400, 380, 420, 400, 640, 340, 460, 440, 480, 460, 600, 880, 920,
    ],
  },
  {
    title: 'Store Actions',
    value: '325',
    interval: 'Last 30 days',
    trend: 'down',
    data: [
      50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200,
      190, 180, 170, 160, 150, 230, 210, 200, 190, 180, 170, 160, 150, 140
    ],
  },
  {
    title: 'Event count',
    value: '200k',
    interval: 'Last 30 days',
    trend: 'neutral',
    data: [
      500, 400, 510, 530, 520, 600, 530, 520, 510, 730, 520, 510, 530, 620, 510, 530,
      520, 410, 530, 520, 610, 530, 520, 610, 530, 420, 510, 430, 520, 510,
    ],
  },
];


const ScrollableContainer = styled(Grid)(({ theme }) => ({
  overflowX: 'auto', // Enable horizontal scrolling
  display: 'flex', // Use flexbox for horizontal layout
  boxShadow: theme.shadows[1],
  '&::-webkit-scrollbar': {
    height: '1em',
    padding: '1em',
    width: '5em',
    margin: '1em auto',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadius,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export default function MainGrid() {

  interface Store {
    id: string
    name: string;
    address: string;
    logo: string;
  }

  const [stores, setStores] = useState<Store[]>([]);
  const { translations } = useLanguage(); // ✅ Use translations

  const UserService = createUserService();

  var navigate = useNavigate();

  useEffect(() => {
    UserService.getStoresOfUsers().then((response) => {
      if (response.status === 200) {
        setStores(response.data);
      }
    })
  }, []);

  function handleSgoreEditClick(storeId: string): React.MouseEventHandler<HTMLButtonElement> | undefined {
    return () => {
      navigate(`/store-edit/${storeId}`);
    }
  }

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      {/* cards */}
      <Typography component="h2" variant="h6" sx={{ mb: 2, mt: 4 }}>
        {translations.home_page_section.overview}
      </Typography>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {/* {data.map((card, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 4 }}>
            <StatCard {...card} />
          </Grid>
        ))} */}
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
          <Button
            sx={{ mb: 2, mr: 2 }}
            size="large"
            variant="outlined"
            endIcon={<AddCircle />}
            onClick={() => navigate('/store-creation')}
          >
            {translations.home_page_section.create_new_store}
            </Button>
            <Button
            sx={{ mb: 2 }}
            size="large"
            variant="outlined"
            endIcon={<AddCircle />}
            onClick={() => navigate('/announcement-creation')}
          >
            {translations.home_page_section.new_announcement_creation}
            </Button>
          {<ScrollableContainer >
            {stores.map((store, index) => (
              <Card
                key={index}
                sx={{
                  maxWidth: 345,
                  minWidth: 250, // Set a minimum width for consistent card sizes
                  flex: '0 0 auto', // Ensure cards don't shrink or wrap
                  marginRight: (theme) => theme.spacing(2), // Add spacing between cards
                }}>
                <CardMedia
                  sx={{ height: 190 }}
                  image={store.logo}/>
                <CardContent>
                  <Typography variant="h5" component="div">
                    {store.name}
                  </Typography>

                </CardContent>
                <CardActions >
                  <Button
                    sx={{ ml: 'auto' }}
                    size="small"
                    color="secondary"
                    variant='outlined'
                    onClick={handleSgoreEditClick(store.id)}
                  >
                    {translations.home_page_section.edit}
                    </Button>
                </CardActions>
              </Card>
            ))}
          </ScrollableContainer>}
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SessionsChart />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <PageViewsBarChart />
        </Grid>
      </Grid>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
      {translations.home_page_section.store_action_logs}
      </Typography>
      <Grid container spacing={2} columns={12} >
        <Grid size={{ xs: 12, lg: 12 }}>
          <CustomizedDataGrid />
        </Grid>
      </Grid>
    </Box>
  );
}
